import {Component, Injector} from "@angular/core";
import {RoutesDialogBaseComponent} from "./routes-dialog-base/routes-dialog-base.component";

@Component({
    selector: 'app-create-route',
    templateUrl: './routes-dialog-base/routes-dialog-base.component.html',
    styleUrls: ['./routes-dialog-base/routes-dialog-base.component.css'],
    standalone: false
})
export class CreateRoutesComponent extends RoutesDialogBaseComponent {

  constructor(protected injector:Injector) {
    super(injector);
    this.dialogId = "createRoute";

  }

  public submit() {
    this.model.Id = 0;
    this.routesService.CreateRoute(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          super.submit();
        });
  }
}
